import { emptySplitApi } from './injectApi';

const advancedFeaturesApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAdvancedFeatures: build.query({
      query: () => ({
        url: '/sales-admin/sales/admin/pos-manager/advanced-features',
        method: 'GET',
      }),
    }),
    getAdvancedFeaturesByPartner: build.query({
      query: (id) => ({
        url: `/sales-admin/sales/admin/pos-manager/organizations/${id}/advanced-features`,
        method: 'GET',
      }),
      providesTags: ['AdvancedFeatures'],
    }),
    giveAccess: build.mutation({
      query: ({ partnerId, accessId }) => ({
        url: `/sales-admin/sales/admin/pos-manager/organizations/${partnerId}/advanced-features`,
        method: 'POST',
        data: { advancedFeatureId: accessId },
      }),
      invalidatesTags: ['AdvancedFeatures'],
    }),
    removeAccess: build.mutation({
      query: ({ partnerId, accessId }) => ({
        url: `/sales-admin/sales/admin/pos-manager/organizations/${partnerId}/advanced-features`,
        method: 'DELETE',
        data: { advancedFeatureId: accessId },
      }),
      invalidatesTags: ['AdvancedFeatures'],
    }),
  }),
});

export const advancedFeaturesApiHook = {
  useGetAdvancedFeatures: advancedFeaturesApi.useGetAdvancedFeaturesQuery,
  useGetAdvancedFeaturesByPartner: advancedFeaturesApi.useLazyGetAdvancedFeaturesByPartnerQuery,
  useGiveAcess: advancedFeaturesApi.useGiveAccessMutation,
  useRemoveAccess: advancedFeaturesApi.useRemoveAccessMutation,
};
